// Informational averages from frozen timesheet dates, never from payroll quantities.
function summarize(parts, explanation = false) {
    const unknown = {minutes: null, days: null, average: null};
    if (!parts.length) return unknown;
    const seen = new Set(), dates = new Set();
    let minutes = 0;
    for (const part of parts) {
        const details = part.source_details || {};
        const lineId = part.line_id || details.line_id;
        const key = part.revision_id && part.timesheet_id && lineId
            ? `${part.revision_id}:${part.timesheet_id}:${lineId}` : null;
        if (key && seen.has(key)) continue;
        if (key) seen.add(key);
        const records = explanation ? part.days : details.days;
        // A mismatch with payroll quantities does not change the factual hours.
        // Missing old snapshots have no dates and an explicit evidence error.
        if (!Array.isArray(records) || explanation && part.days_error && !records.length) return unknown;
        for (const record of records) {
            const raw = explanation ? record.minutes : record.worked_minutes;
            const value = Number(raw), date = String(record.date || '').slice(0, 10);
            if (raw == null || raw === '' || !Number.isFinite(value) || value < 0 || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return unknown;
            if (value > 0) { minutes += value; dates.add(date); }
        }
    }
    return {minutes, days: dates.size, average: dates.size ? minutes / 60 / dates.size : null};
}

const number = value => String(Number(Number(value).toFixed(2))).replace('.', ',');
const text = summary => summary.average == null ? '—' : number(summary.average);
function hint(summary) {
    if (summary.minutes == null) return 'Недостаточно подробностей табеля для среднего.';
    if (!summary.days) return 'Нет дат с рабочими часами.';
    const hours = summary.minutes % 3 === 0 ? `${number(summary.minutes / 60)} ч`
        : `${Math.floor(summary.minutes / 60)} ч ${number(summary.minutes % 60)} мин`;
    const days = summary.days, word = days % 10 === 1 && days % 100 !== 11 ? 'рабочий день'
        : days % 10 >= 2 && days % 10 <= 4 && !(days % 100 >= 12 && days % 100 <= 14) ? 'рабочих дня' : 'рабочих дней';
    return `${hours} ÷ ${days} ${word}. По часам из табелей, без ручных поправок начисления.`;
}

module.exports = {summarize, text, hint};
